export const CHROME_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.ChromeTemplateInterface.ChromeTemplate';
